
export enum AppPermissions {
    PublicAccess = 'PublicAccess',
    AuthenticatedUser = 'AuthenticatedUser',
}
